/**
 * Tauri Navigation Utilities
 * Handles navigation that needs to open external browser when in Tauri app
 */

/**
 * Detect if running in Tauri environment
 */
export function isTauriEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  return !!(window as any).__TAURI_IPC__ || !!(window as any).__TAURI_INTERNALS__;
}

/**
 * Navigate to a path, opening browser if in Tauri, otherwise using Next.js router
 * @param path - The path to navigate to (e.g., '/pro', '/login')
 * @param router - Next.js router instance (optional, only needed for web fallback)
 */
export async function navigateOrOpenBrowser(
  path: string,
  router?: { push: (path: string) => void }
): Promise<void> {
  const isTauri = isTauriEnvironment();

  if (isTauri) {
    try {
      const { open } = await import('@tauri-apps/plugin-shell');
      const appUrl = process.env.NEXT_PUBLIC_APP_URL || 'https://visualgrid.app';
      await open(`${appUrl}${path}`);
    } catch (error) {
      console.error('Erreur lors de l\'ouverture du navigateur:', error);
      if (router) {
        router.push(path);
      }
    }
  } else {
    if (router) {
      router.push(path);
    }
  }
}
